import axios from "axios";
import instance from "../Config/Config";
import { API_BASE } from "../utils/baseUrls";

export const geo_url = "geo"
export const market_url = "market"
export const syndicate_url = "synticate"
export const profile_url = "get_profile"
export const market_details_url = "market"
export const syndicate_details_url = "synticate"
export const material_url = "material_list"
export const service_url = "services_list"
export const material_details = "material"
export const serviceList = "services_list"
export const service_enquiry_url = "services_enquriy"
export const update_profile_url = "profile_update"
export const update_referral_url = "get_profile_Ref"
export const kyc_store_url = "kyc"
export const kyc_list_url = "kyc_list";
// 23/12/25
export const plot_profile_url = "polt"
export const material_cat_url = "material_category"
export const material_sub_cat_url = "material_sub_cat"
export const material_sub_sub_cat_url = "material_sub_sub_cat"
export const material_brand_url = "brands"


//add property
export const add_property_url = "market_store"
export const update_property_url = "market_update"
export const get_property_url = "market_list"
export const get_delete_url = "market_property_delete"

//cities,states,country property Type
export const get_country_url = "country"
export const get_state_url = "state"
export const get_city_url = "city"
export const get_property_type_url = "property_category"

// 13/12/25
export const get_banner_url = "carousel_banner"
export const get_geo_featured_url = "featured"
export const get_market_featured_url = "featured"
// 14/12/25
export const get_synticate_featured_url = "featured"
export const get_top_banner_url = "top_banner"
export const get_services_featured_list_url = "services_featured_list"
export const get_material_featured_list_url = "material_featured_list"
// 23/12/25
export const get_plots_list_url = "plots"
export const get_plots_detailsview_url = "plot_details"


// 26/12/25
export const post_plots_enquiry_url = "market_enquiry"
//30/12/12

export const get_nearby_place_url = "nearby_place"
export const get_amenities_url = "amenities"
export const get_owners_url = "owners"
export const get_agents_ur = "agents"
export const get_common_facilities_url = "common-facilities"


//2/1/26
export const get_gio_buying_list_url = "gioo_buying_list"
export const get_gio_buying_list_detail_url = "gioo_buying_list_details"

export const gioo_buying_cancel_url = "gioo_buying_cancel_request"
export const get_syndicate_buying_list_detail_url = "syndicate_buying_list_details"
export const syndicate_buying_cancel_url = "syndicate_buying_cancel_request"



// 03/01/26
export const my_residential_plots_url = "my_residential_plots"
export const my_plot_category_url = "plot_category"
export const my_plot_facility_url = "plot_facility"
export const my_plot_store_url = "plot_store"
export const my_residential_plots_delete_url = "my_residential_plots"

// 05/01/26
export const update_residential_property_url = "plot_edit"
export const update_residential_plot_url = "plot_update"
export const update_edit_property_url = "market_property_edit"


export const get_syndicate_buy_list_url = "syndicate_buying_list"


export const store_referral_url = "store-referral"
// 13/1/26
export const post_residential_enquiry_url = "plot_enquiry"
export const residential_enquiry_list_url = "plot_enquiry_list"



export const delete_old_image_residential_url = "plot"
export const delete_old_image_market_url = "market"
// 
//22/1/26 rental
export const rental_url = "rental"
export const rental_details_url = "rental_details"
export const rental_enquiry_url = "rental_enquiry"
export const rental_enquiry_list_url = "rental_enquiry_list"
// homepage features
export const residential_featurelist_url = "featured"
export const rental_featurelist_url = "featured"

export const upload_market_document_url = "market_document"
// 
// 29/1/26
export const market_enquiry_url = "market_enquiry_list"
export const market_uploaded_doc_delete_url = "property/document/delete"
// 7/2/26 material store
export const material_store_url = "vendor"
export const material_store_detail_url = "vendor"
export const post_review_url = "shop/review"

// 9/2/26 perfestionl service
export const proffessional_service_url = "vendor/service"
export const proffessional_service_detail_url = "vendor/service"
export const preffessional_review_url = "vendor"
// 10/2/26
export const material_enquriypost_url = "material_enquriy"
export const profssional_enquriypost_url = "services_enquriy"
// 
//11/2/26
export const material_request_url = "vendor_materials_request"
export const service_request_url = "vendor_services_request"
export const vendor_material_enquriy_url = "material_all"
export const vendor_profssional_enquriy_url = "services_all"
export const vendor_material_enquriylist_url = "vendor_materials_list"
export const vendor_profssional_enquriylist_url = "vendor_services_list"
export const wallet_transactions_url = "wallet-transactions"
export const generate_coupon_url = "generate-coupon"
export const coupon_list_url = "coupon-list"
export const coupon_cancel_url = "coupon-cancel"
export const coupon_delete_url = "coupon"
export const enhance_coupon_check_url = "enhance_coupon_check"
export const enhancement_url = "enhancement"
export const enhancement_list_url = "enhancement_list"
export const service_featured_category_list_url = "service-featured-category-list"
export const apply_coupon_url = "apply-coupon"
export const settings_url = "settings"
export const notifications_url = "user/notifications"
export const services_material_banner_url = "services_material_banner"
export const notification_count_url = "user/notification-count"
export const clear_notifications_url = "user/notifications/clear"
export const mark_notification_read_url = "user/notifications/mark-as-read"
export const mark_all_notifications_read_url = "user/notifications/mark-all-read"
export const delete_notification_url = "notification"
export const delete_all_notifications_url = "notifications/delete-all"
export const kyc_verification_url = "kyc_verification"
export const coupon_invoice_download_url = "coupon-invoice-download"


export const get_geo_fun = async (params = {}, page = 1) => {
    const response = await instance.get(geo_url, {
        params: {
            ...params,
            page_no: page,
        },
    });
    return response.data;
};



export const get_profile = async () => {
    const response = await instance.get(`${profile_url}`)
    return response.data
}

export const update_profile = async (value) => {
    const response = await instance.post(`${update_profile_url}`, value)
    return response.data
}

export const update_referral = async (value) => {
    const response = await instance.post(`${update_referral_url}`, value)
    return response.data
}

export const get_market_fun = async (params = {}, page = 1) => {
    const response = await instance.get(market_url, {
        params: {
            ...params,
            page_no: page,
        },
    });
    return response.data;
};

export const add_kyc = async (value) => {
    const response = await instance.post(`${kyc_store_url}`, value)
    return response.data
}

export const get_kyc_list = async () => {
    const response = await instance.get(`${kyc_list_url}`);
    return response.data;
};

export const kyc_update = (id, data) =>
    instance.post(`/kyc-update/${id}`, data, {
        headers: { "Content-Type": "application/json" },
    });

export const kyc_delete = (id) =>
    instance.post(`/kyc-delete/${id}`);

export const kyc_verification = async (value) => {
    const response = await instance.post(`${kyc_verification_url}`, value)
    return response.data
}



export const get_syndicate_fun = async (params = {}, page = 1) => {
    const response = await instance.get(syndicate_url, {
        params: {
            ...params,
            page_no: page,
        },
    });
    return response.data;
};

export const get_market_property = async (id) => {
    const response = await instance.get(`property_details/${market_details_url}/${id}`)
    return response?.data
}

export const get_geo_property = async (id) => {
    const response = await instance.get(`property_details/${geo_url}/${id}`)
    return response?.data
}

export const get_synticate_property = async (id) => {
    const response = await instance.get(`property_details/${syndicate_url}/${id}`)
    return response?.data
}

export const material_list = async (params = {}) => {
    const response = await instance.get(`${material_url}`, { params })
    return response.data
}

export const get_material_categories = async () => {
    const response = await instance.get(`${material_cat_url}`)
    return response.data
}

export const get_material_sub_categories = async (catId) => {
    const response = await instance.get(`${material_sub_cat_url}/${catId}`)
    return response.data
}

export const get_material_sub_sub_categories = async (subCatId) => {
    const response = await instance.get(`${material_sub_sub_cat_url}/${subCatId}`)
    return response.data
}

export const get_material_brands = async () => {
    const response = await instance.get(`${material_url}`)
    return response.data
}


export const get_material_details = async (id) => {
    const response = await instance.get(`${material_details}/${id}`)
    return response?.data
}

export const get_service_list = async (params = {}) => {
    const response = await instance.get(`${service_url}`, { params })
    return response.data
}


//for service enquiry
export const service_enquiry = async (value) => {
    const response = await instance.post(`${service_enquiry_url}`, value)
    return response.data
}


//for adding/updating property
export const add_property = async (value) => {
    const response = await instance.post(`${add_property_url}`, value)
    return response.data
}


export const update_property = async (value) => {
    const response = await instance.post(`${update_property_url}`, value)
    return response.data
}


//for adding/enquiry_property
export const plot_enquiry_property_url = async (value) => {
    const response = await instance.post(`${post_plots_enquiry_url}`, value)
    return response.data
}

//for residential enquiry
export const residential_enquiry = async (value) => {
    const response = await instance.post(`${post_residential_enquiry_url}`, value)
    return response.data
}

export const get_property = async () => {
    const response = await instance.get(`${get_property_url}`)
    return response.data
}
//
//for states , cities
export const get_country = async (params = {}) => {
    const response = await instance.get(`${get_country_url}`, { params })
    return response.data
}

export const get_state = async (params = {}) => {
    const response = await instance.get(`${get_state_url}`, { params })
    return response.data
}

export const get_city = async (params = {}) => {
    const response = await instance.get(`${get_city_url}`, { params })
    return response.data
}

export const get_property_type = async () => {
    const response = await instance.get(`${get_property_type_url}`)
    return response.data
}

// 13/12/25 home sliderbanner

export const get_slider_banner = async () => {
    const response = await instance.get(`${get_banner_url}`)
    return response.data
}
//Featured GIOO Plots Properties

export const get_geo_featured = async () => {
    const response = await instance.get(`geo/${get_geo_featured_url}`)
    return response.data
}

//market_featured
export const get_market_featured = async () => {
    const response = await instance.get(`market/${get_market_featured_url}`)
    return response.data
}

// 15/12/25
// //syndicate_featured
export const get_syndicate = async () => {
    const response = await instance.get(`synticate/${get_synticate_featured_url}`)
    return response.data
}
// top_banner
export const get_top_banner = async () => {
    const response = await instance.get(`/${get_top_banner_url}`)
    return response.data
}

// // services_featured_list
export const get_services_featured_list = async () => {
    const response = await instance.get(`/${get_services_featured_list_url}`)
    return response.data
}
// material_featured_list
export const get_material_featured_list = async () => {
    const response = await instance.get(`${get_material_featured_list_url}`)
    return response.data
}

export const get_plot_list = async (params = {}, page = 1) => {
    const response = await instance.get(get_plots_list_url, {
        params: {
            ...params,
            page_no: page,
        },
    });
    return response.data;
};
// geo_url, { params }
export const get_plot_detailsview = async (id) => {
    const response = await instance.get(`${get_plots_detailsview_url}/${id}`)
    return response.data
}
// 30/12/12

export const get_nearby_place = async () => {
    const response = await instance.get(`${get_nearby_place_url}`)
    return response.data
}
export const get_amenities = async () => {
    const response = await instance.get(`${get_amenities_url}`)
    return response.data
}
export const get_owners = async () => {
    const response = await instance.get(`${get_owners_url}`)
    return response.data
}
export const get_agents = async () => {
    const response = await instance.get(`${get_agents_ur}`)
    return response.data
}

export const get_common_facilities = async () => {
    const response = await instance.get(`${get_common_facilities_url}`)
    return response.data
}

export const get_property_delete = async (id) => {
    const response = await instance.post(`${get_delete_url}/${id}`)
    return response.data
}


//buying list gioo
export const get_gio_buying_list = async (page) => {
    const response = await instance.get(`${get_gio_buying_list_url}?page_no=${page}`)
    return response.data
}


export const get_gio_buying_detail = async (id, page) => {
    const response = await instance.get(`${get_gio_buying_list_detail_url}?tran_id=${id}&page_no=${page}`)
    return response.data
}
// plot/{plotId}/image/{imagePath}
export const delete_old_image_residential = async (id, image) => {
    const response = await instance.delete(`${delete_old_image_residential_url}/${id}/image/${image}`)
    return response.data
}
export const delete_old_image_market = async (id, image) => {
    const response = await instance.get(`${delete_old_image_market_url}/image/delete`, {
        params: { id: id, path: image },
    });
    return response.data
}
export const gioo_buying_cancel_request = async (id) => {
    const token = localStorage.getItem("authToken");
    const response = await instance.get(`${gioo_buying_cancel_url}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    return response.data
}
export const syndicate_buying_cancel_request = async (id) => {
    const token = localStorage.getItem("authToken");
    const response = await instance.get(`${syndicate_buying_cancel_url}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    return response.data
}
// 03/1/26
export const my_residential_plots = async () => {
    const response = await instance.get(`${my_residential_plots_url}`)
    return response.data
}

export const my_plot_category = async () => {
    const response = await instance.get(`${my_plot_category_url}`)
    return response.data
}
export const my_plot_facility = async (id) => {
    const response = await instance.get(`${my_plot_facility_url}/${id}`)
    return response.data
}
export const get_plot_store = async (value) => {
    const response = await instance.post(`${my_plot_store_url}`, value)
    return response.data
}
export const get_plot_store_delete = async (id) => {
    const response = await instance.delete(`${my_residential_plots_delete_url}/${id}`)
    return response.data
}
export const update_residential_property = async (id) => {
    const response = await instance.get(`${update_residential_property_url}/${id}`)
    return response.data
}

export const update_edit_property = async (id) => {
    const response = await instance.get(update_edit_property_url, {
        params: { id: id },
    });
    return response.data;
};


export const update_residential_store = async (value) => {
    const response = await instance.post(`${update_residential_plot_url}`, value)
    return response.data
}
export const residential_enquiry_list = async () => {
    const response = await instance.get(`${residential_enquiry_list_url}`)
    return response.data
}

//syndicate buying list 
export const get_syndicate_buying_list = async (page) => {
    const response = await instance.get(`${get_syndicate_buy_list_url}?page_no=${page}`)
    return response.data
}

export const get_syndicate_buying_detail = async (id, page) => {
    const response = await instance.get(`${get_syndicate_buying_list_detail_url}?tran_id=${id}&page_no=${page}`)
    return response.data
}

export const store_referral = async (value) => {
    const response = await instance.post(`${store_referral_url}`, value)
    return response.data
}

// 22/12/26 rental list& details

export const get_rental_list = async (params = {}, page = 1) => {
    const response = await instance.get(rental_url, {
        params: {
            ...params,
            page_no: page,
        },
    });
    return response.data;
};

export const get_rental_details = async (id) => {
    const response = await instance.get(`${rental_details_url}/${id}`)
    return response.data
}

export const rental_enquiry = async (value) => {
    const response = await instance.post(`${rental_enquiry_url}`, value)
    return response.data
}
export const rental_enquiry_list = async () => {
    const response = await instance.get(`${rental_enquiry_list_url}`)
    return response.data
}

// homepage features list rental&residential
export const residential_list = async () => {
    const response = await instance.get(`plot/${residential_featurelist_url}`)
    return response.data
}
export const rental_list = async () => {
    const response = await instance.get(`rental/${rental_featurelist_url}`)
    return response.data
}

export const market_document_upload = async (value) => {
    const response = await instance.post(`${upload_market_document_url}`, value)
    return response.data
}
// 29/1/26
export const market_enquiry = async () => {
    const response = await instance.get(`${market_enquiry_url}`)
    return response.data
}

export const market_uploaded_doc_delete = async (id) => {
    const response = await instance.delete(`${market_uploaded_doc_delete_url}/${id}`)
    return response.data
}

//7/2/26
export const get_material_store = async (params = {}) => {
    const response = await instance.get(`${material_store_url}`, { params })
    return response.data
}
export const get_material_detailview = async (id) => {
    const response = await instance.get(`${material_store_detail_url}/${id}`)
    return response.data
}

export const material_review = async (value) => {
    const response = await instance.post(`${post_review_url}`, value)
    return response.data
}
export const post_material_enquriy = async (value) => {
    const response = await instance.post(`${material_enquriypost_url}`, value)
    return response.data
}
// proffessionalservice 

export const get_proffessional_service = async (params = {}) => {
    const response = await instance.get(`${proffessional_service_url}`, { params })
    return response.data
}


export const get_proffessional_detailview = async (id) => {
    const response = await instance.get(`${proffessional_service_detail_url}/${id}`)
    return response.data
}

export const professional_review = async (value) => {
    const response = await instance.post(`${preffessional_review_url}`, value)
    return response.data
}

export const post_profssional_enquriy = async (value) => {
    const response = await instance.post(`${profssional_enquriypost_url}`, value)
    return response.data
}

// Service Sub Categories
export const get_service_sub_categories = async (catId) => {
    const response = await instance.get(`services_sub_cat/${catId}`)
    return response.data
}

export const get_service_sub_sub_categories = async (subCatId) => {
    const response = await instance.get(`services_sub_sub_cat/${subCatId}`)
    return response.data
}

// 11/2/26 dashoboard material and service 
export const material_request = async (value) => {
    const response = await instance.post(`${material_request_url}`, value)
    return response.data
}
export const service_request = async (value) => {
    const response = await instance.post(`${service_request_url}`, value)
    return response.data
}

export const vendor_material_list = async () => {
    const response = await instance.get(`${vendor_material_enquriy_url}`)
    return response.data
}
export const vendor_professional_list = async () => {
    const response = await instance.get(`${vendor_profssional_enquriy_url}`)
    return response.data
}

export const vendor_material_enquriylist = async () => {
    const response = await instance.get(`${vendor_material_enquriylist_url}`)
    return response.data
}

export const delete_vendor_material = async (id) => {
    const response = await instance.post(`vendor-material/delete/${id}`)
    return response.data
}
export const vendor_professional_enquriylist = async () => {
    const response = await instance.get(`${vendor_profssional_enquriylist_url}`)
    return response.data
}

export const delete_vendor_service = async (id) => {
    const response = await instance.post(`vendor-service/delete/${id}`);
    return response.data;
};

export const get_wallet_transactions = async (page = 1) => {
    const response = await instance.get(`${wallet_transactions_url}?page=${page}`);
    return response.data;
};
export const generate_coupon = async (payload) => {
    const response = await instance.post(`${generate_coupon_url}`, payload);
    return response.data;
};


export const get_coupon_list = async (page = 1) => {
    const response = await instance.get(`${coupon_list_url}?page=${page}`);
    return response.data;
};

export const cancel_coupon = async (id) => {
    const response = await instance.post(`${coupon_cancel_url}/${id}`);
    return response.data;
};

export const delete_coupon = async (id) => {
    const response = await instance.delete(`${coupon_delete_url}/${id}`);
    return response.data;
};

export const get_coupon_invoice_download = (id) =>
    instance.get(`${coupon_invoice_download_url}/${id}`, { responseType: 'blob' });

export const get_units = async () => {
    const response = await instance.get("units");
    return response.data;
};

export const check_enhance_coupon = async (code) => {
    const response = await instance.get(`${enhance_coupon_check_url}`, {
        params: { generate_coupon_code: code }
    });
    return response.data;
};

export const submit_enhancement = async (payload) => {
    const response = await instance.post(`${enhancement_url}`, payload);
    return response.data;
};

export const get_enhancement_list = async (userId) => {
    const response = await instance.get(`${enhancement_list_url}${userId ? `?id=${userId}` : ''}`);
    return response.data;
};

export const get_featured_service_categories = async () => {
    const response = await instance.get(`${service_featured_category_list_url}`);
    return response.data;
};

export const apply_coupon = async (code) => {
    const response = await instance.post(apply_coupon_url, null, {
        params: { coupon_code: code }
    });
    return response.data;
};


export const get_settings = async () => {
    const response = await instance.get(`${settings_url}`);
    return response.data;
};

export const get_services_material_banner = async () => {
    const response = await instance.get(`${services_material_banner_url}`);
    return response.data;
};

export const get_notifications = async (page = 1) => {
    const response = await instance.get(`${notifications_url}`, { params: { page } });
    return response.data;
};

export const get_notification_count = async () => {
    const response = await instance.get(`${notification_count_url}`);
    return response.data;
};

export const clear_notifications = async () => {
    const response = await instance.post(`${clear_notifications_url}`);
    return response.data;
};

export const mark_notification_read = async (id) => {
    const response = await instance.post(`${mark_notification_read_url}/${id}`);
    return response.data;
};

export const mark_all_notifications_read = async () => {
    const response = await instance.post(`${mark_all_notifications_read_url}`);
    return response.data;
};

export const delete_notification = async (id) => {
    const response = await instance.delete(`${delete_notification_url}/${id}`);
    return response.data;
};

export const delete_all_notifications = async () => {
    const response = await instance.delete(`${delete_all_notifications_url}`);
    return response.data;
};

// Search API (public endpoint)
const SEARCH_BASE = `${API_BASE}search`;
// type map from CategorySelector values → API property_type param value
export const SEARCH_TYPE_MAP = {
    "all": "all",
    "Land": "market",
    "Gioo Nano plots": "geo",
    "Gio Rental Yield - Syndicate plots": "syndicate",
    "Gio Rental Yield": "rental",
    "flats/villas": "plot",
};

export const search_properties = async (query = "", type = "all", page = 1) => {
    const params = { page: page };
    if (query.trim()) params.search = query.trim();
    const mappedType = SEARCH_TYPE_MAP[type] ?? type;
    if (mappedType) params.property_type = mappedType;
    const response = await axios.get(SEARCH_BASE, { params });
    return response.data;
};


export const purchase_bank_details_url = "purchase_bank_details"

export const post_purchase_bank_details = async (value) => {
    const response = await instance.post(`${purchase_bank_details_url}`, value)
    return response.data;
};

export const get_purchase_bank_details = async (property_id, type) => {
    const params = {};
    if (property_id) params.property_id = property_id;
    if (type) params.type = type;
    const response = await instance.get(`bank-details`, { params });
    return response.data;
};

export const get_all_bank_details = async () => {
    const response = await instance.get(`admin/bank-details`);
    return response.data;
};

export const add_user_bank_details = async (value) => {
    const response = await instance.post(`bank-details`, value);
    return response.data;
};

export const update_user_bank_details = async (id, value) => {
    const response = await instance.put(`bank-details/${id}`, value);
    return response.data;
};

export const delete_user_bank_details = async (id) => {
    const response = await instance.delete(`bank-details/${id}`);
    return response.data;
};

export const renew_plot = async (id) => {
    const response = await instance.get(`renew/${id}`);
    return response.data;
};

export const submit_general_enquiry = async (value) => {
    const response = await instance.post(`submit-enquiry`, value);
    return response.data;
};

export const renew_market = async (id) => {
    const response = await instance.get(`renew_market/${id}`);
    return response.data;
};

// General Enquiries
export const submit_general_land_enquiry = async (value) => {
    const response = await instance.post(`general-land-enquiry/store`, value);
    return response.data;
};

export const submit_general_residential_enquiry = async (value) => {
    const response = await instance.post(`general-residential-enquiry/store`, value);
    return response.data;
};

export const get_my_general_enquiries = async () => {
    const response = await instance.get(`my-general-enquiries`);
    return response.data;
};

export const get_general_enquiry_details = async (type, id) => {
    const response = await instance.get(`my-general-enquiry/${type}/${id}`);
    return response.data;
};

export const resubmit_general_land_enquiry = async (id, value) => {
    const response = await instance.post(`my-general-enquiry/land/${id}/resubmit`, value);
    return response.data;
};

export const resubmit_general_residential_enquiry = async (id, value) => {
    const response = await instance.post(`my-general-enquiry/residential/${id}/resubmit`, value);
    return response.data;
};

// Wallet Withdrawal Requests
export const submit_withdrawal_request = async (value) => {
    const response = await instance.post(`withdraw-request/store`, value);
    return response.data;
};

export const get_withdrawal_history = async () => {
    const response = await instance.get(`withdraw-requests`);
    return response.data;
};

export const submit_custom_land_enquiry = async (value) => {
    const response = await instance.post(`custom-land-enquiry/store`, value);
    return response.data;
};

export const get_my_custom_land_enquiries = async () => {
    const response = await instance.get(`my-custom-land-enquiries`);
    return response.data;
};

export const get_faqs = async (module) => {
    const response = await instance.get(`faqs/${module}`);
    return response.data;
};
